import { createContext } from "react";

/**
 * NOTE: NSAI-5822 — the element in the app header that a page's breadcrumb is
 * portaled into. The breadcrumb used to be a row of its own under the header,
 * which left a band of empty space above every page; it now sits in the header
 * beside the sidebar's collapse control.
 *
 * Null outside `AppLayout` — the admin layout has its own chrome — and `Toolbar`
 * falls back to rendering in place there.
 */
export const HeaderSlotContext = createContext<HTMLElement | null>(null);
